import { Border } from '@sketch/scene-model'
import { formatCssRgbaColor } from './formatCssRgbaColor'

/**
 * The CSS colour to draw a border in, as an `rgba()` string.
 *
 * A `Border` carries either a `color` or a `gradient`. Gradient borders are not
 * really supported: the old inspector data came with a `color` alongside the
 * gradient and that is what was shown, so the last gradient stop is used to
 * approximate it. Returns `undefined` for a border that carries neither.
 *
 * Shared with the Components web view's "Copy CSS", which serialises a parsed
 * style rather than a scene element and so cannot use the CSS generator.
 */
export function getBorderColor(border: Border) {
  if (border.color) {
    return formatCssRgbaColor(border.color)
  }

  if (border.gradient) {
    const stops = border.gradient.stops
    const lastStop = stops[stops.length - 1]

    return lastStop && formatCssRgbaColor(lastStop.color)
  }

  return undefined
}
